export class NotAuthenticatedException extends Error {}